import { Condition, SellNowFormStep, SellProductStatus } from '../enums';

export interface Accessory {
    id?: string;
    label: string;
    isSelected: boolean;
}

export interface ListItemProduct {
    title: string;
    subtitle: string;
    image: string;
    isChecked: boolean;
}

export interface SellNowSteps {
    id?: string;
    currentStep: SellNowFormStep;
    productInfo: {
        firstName: string;
        lastName: string;
        phone: string;
        brand: string;
        condition: Condition;
        model: string;
        price: number;
        accessories: Accessory[];
    };
    images: {
        front: string;
        back: string;
        bottom: string;
        interior: string;
        additional: string[];
    };
    recentProducts: ListItemProduct[];
    referralCode: string;
    gdprVersion?: string;
    tcVersion?: string;
}

export interface SellNowTimeline {
    items: TimelineItem[];
    product: SellNowProduct;
}

export interface SellNowProduct {
    brand: string;
    model?: string;
    condition: Condition;
    id: string;
    sellID: string;
    date: Date;
    image: string;
    isCounterfeit: boolean;
    currency: string;
    ownerEmail?: string;
}

export interface SellNowItem {
    id: string;
    orderId: number;
    brand: string;
    productName: string;
    price: number;
    productImage: string;
    actionNeeded: string;
    currency: string;
    status?: SellProductStatus;
}

export interface SellNowDividerItem {
    divider: string;
    products: SellNowItem[];
}

export type TimelineActions = 'confirmAddress' | 'rejectPrice' | 'acceptPrice' | 'negotiatePrice';

export interface DescriptionWidget {
    type: 'description';
    value: {
        info: string[];
    };
}

export interface StatusWidget {
    type: 'status';
    value: {
        status: string;
        statusColor: string;
    };
}

export interface TitleWidget {
    type: 'title';
    value: { text: string; color?: string };
}

export interface MotiveWidget {
    type: 'motive';
    value: string;
}

export interface InfoKeyValuesWidget {
    type: 'infoKeyValues';
    value: {
        displayOnTwoColumns: boolean;
        keyValues: { key: string; value: string }[];
    };
}

export interface ImagesWidget {
    type: 'images';
    value: string[];
}

export interface QuotationWidget {
    type: 'quotation';
    value: {
        price: string;
        displayActions: boolean;
    };
}

export interface ActionWidget {
    type: 'action';
    value: {
        onTwoColumns: boolean;
        actions: TimelineActions[];
        defaults?: { [key: string]: string };
    };
}
export interface LinkWidget {
    type: 'link';
    value: {
        onTwoColumns: boolean;
        links: { text: string; link: string }[];
    };
}

export interface DownloadWidget {
    type: 'download';
    value: {
        onTwoColumns: boolean;
        files: { name: string; file: string }[];
    };
}

export interface TimelineWidget {
    type: 'timeline';
    value: {
        items: TimelineWidgetItem[];
        infoText: string;
    };
}

export interface TimelineWidgetItem {
    date: Date;
    customerProposal: string;
    adminProposal: string;
    isApproved: boolean;
    isPending: boolean;
}

export type Widget =
    | DescriptionWidget
    | StatusWidget
    | TitleWidget
    | MotiveWidget
    | InfoKeyValuesWidget
    | ImagesWidget
    | QuotationWidget
    | ActionWidget
    | LinkWidget
    | DownloadWidget
    | TimelineWidget;

export interface TimelineItem {
    isCurrent: boolean;
    isDone: boolean;
    isFuture: boolean;
    // Show this if showLongVersion is true
    widgets: Widget[];
    // Show this if showLongVersion is false
    shortVersionWidgets?: Widget[];
    // If this is true, user can click on the item and put showLongVersion to true
    hasLongVersion: boolean;
    showLongVersion: boolean;
}
